import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { useMutation } from 'react-query';
import { UserDoc, UserUpdatePartialDoc } from 'types/user';
import { AxiosError } from 'axios';

export const useUpdateUserPartial = () => {
  const authState = useAuthSelector();
  return useMutation<any, AxiosError, Partial<UserDoc>, unknown>(
    async userUpdatePartialDoc =>
      sdk.user.mutate.updatePartial(
        userUpdatePartialDoc,
        authState?.auth_token,
      ),
  );
};
